import { NavLink } from "react-router-dom";

const items = [
  { label: "首页", icon: "ri-home-5-line", activeIcon: "ri-home-5-fill", to: "/" },
  { label: "分类", icon: "ri-apps-2-line", activeIcon: "ri-apps-2-fill", to: "/category/entertainment" },
  { label: "搜索", icon: "ri-search-line", activeIcon: "ri-search-fill", to: "/search" },
  { label: "专题", icon: "ri-bookmark-3-line", activeIcon: "ri-bookmark-3-fill", to: "/topic/topic-drama-2026" },
  { label: "关于", icon: "ri-information-line", activeIcon: "ri-information-fill", to: "/about" },
];

export default function MobileTabBar() {
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-background-50/98 backdrop-blur border-t border-background-300/80">
      <div className="flex items-stretch">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) =>
              [
                "flex-1 flex flex-col items-center justify-center gap-1 py-2.5 cursor-pointer transition-colors",
                isActive ? "text-primary-600" : "text-foreground-500",
              ].join(" ")
            }
          >
            {({ isActive }) => (
              <>
                <i className={`${isActive ? item.activeIcon : item.icon} text-xl leading-none`} />
                <span className="text-[11px] leading-none">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
}